const LOGIN_URL = "/auth/login"
const FORGOT_PASSWORD = "/auth/esqueci-senha"
const FIRST_ACCESS = "/conta/primeiro-acesso"
import BaseService from '@/services/base_service';

export default class AuthService extends BaseService {
    async login(user) {
      try {
        let token = btoa(user.email + ':' + user.senha);
        let auth_header = 'Basic ' + token;

        const response = await axios.get(LOGIN_URL, {
          headers: {Authorization: auth_header, Accept: 'application/json'}
        });

        console.log(response);

        if (response.status === 200) {
          let user = response.data.data;

          if (user.ativo) {
            user.token = token;
            this.setUser(user);
          }

          return user;
        }
      } catch (e) {
        console.log(e)
        throw this.getErrors(e);
      }
    }

    async forgotPassword(model) {
        return new Promise((resolve, reject) => {
            window.axios.post(FORGOT_PASSWORD, model).then(response => {
                if (response.status === 200) {
                    resolve(response.data.data);
                }
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    firstAccess(user) {
        return new Promise((resolve, reject) => {
            let userStorage = this.getUser();
            let auth_header = 'Basic ' + userStorage.token;

            window.axios.post(FIRST_ACCESS, user, {
                headers: {Authorization: auth_header, Accept: 'application/json'}
            }).then(response => {
                if (response.status === 200) {
                    userStorage.token = btoa(userStorage.username + ':' + user.password);
                    this.setUser(user);
                }

                resolve(true);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    logout() {
        window.localStorage.removeItem('dwpets');
    }

    isLoggedIn() {
        let user = this.getUser();
        return user != undefined && user != null && !user.bloqueado && user.ativo && user.token;
    }

    isAdmin() {
        let user = this.getUser();
        return user.perfil == 'A';
    }

    setUser(user) {
        window.localStorage.setItem('dwpets', JSON.stringify(user));
    }

    getUser() {
        return JSON.parse(window.localStorage.getItem('dwpets'));
    }

    getUserDetail(user) {
        return axios.get('/api/meu-usuario', {
            headers: {
                'Authorization': 'Basic ' + user.token
            }
        });
    }

    hasPermission(permisssion) {

        if (this.getUser() === undefined || this.getUser() === null) {
            return false;
        }

        const permissionList = this.getUser().permissoes;

        return _.indexOf(permissionList, permisssion) === 1
    }

    hasRole(roles) {

        if (this.getUser() === undefined || this.getUser() === null) {
            return false;
        }

        let hasRole = false

        if (roles instanceof Array) {
            hasRole = _.indexOf(roles, this.getUser().perfil) !== -1
        } else {
            hasRole = this.getUser().perfil === roles
        }

        return hasRole

    }

    static listCompanies() {
        return window.axios.get('/conta/minhas-empresas')
    }

    static changeUserCompanyDefault(companyId) {
        return window.axios.post('/conta/alterar-empresa', {
            idEmpresa: companyId
        })
    }

    static getUserDefaultCompany() {
        return window.axios.get('/conta/empresa-ativa')
    }

    refreshToken() {
        return new Promise((resolve, reject) => {
            const user = getUser();

            window.axios.interceptors.response.use((config) => {
                return config
            }, (err) => {
                return Promise.reject()
            })
            window.axios.get(LOGIN_URL).then(response => {
                console.log('REFRESH TOKEN');
                console.log(response);
                resolve(true);
                // let user = {}
                //
                // if (response.status === 200) {
                //     user.access_token = response.data.access_token
                //     user.refresh_token = response.data.refresh_token
                // }
                //
                // setUser(user)
                //
                // getUserDetail(user).then(response => {
                //     user.name = response.data.name
                //     user.email = response.data.email
                //     setUser(user);
                //     resolve(user.access_token)
                // })
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/auth.js